import Banner from "ds/components/Banner";
import FeedbackActions from "ds/components/Feedback/Actions";
import Link from "ds/components/Link";
import { OPEN_TOFU_MIGRATION_GUIDE_URL } from "shared/Stack/OpenTofuMigration/constants";

const DashboardWidgetsOpenTofuMigrationDeprecationBanner = () => (
  <Banner variant="info" fullWidth title="Move your OpenTofu stacks to the native OpenTofu vendor">
    Native OpenTofu stacks show you more about every run: downloadable CPU profiles for slow runs,
    structured JSON logs and shorter plan and apply output. Deeper run visibility and diagnostics
    arrive soon, only on native stacks.
    <FeedbackActions>
      <Link size="small" href={OPEN_TOFU_MIGRATION_GUIDE_URL} target="_blank">
        OpenTofu migration guide
      </Link>
    </FeedbackActions>
  </Banner>
);

export default DashboardWidgetsOpenTofuMigrationDeprecationBanner;
